// import * as types from "./../../actions/googleAnalytics/types";

const initialState = {
    beChanged: false,
    eventName: '', 
    params: [], 
    prevAction: '',
};
const googleAnalytics = (state = initialState, action) => {
    switch (action.type) {
        case 'TYPE_CHANGE_EVENT':
            // console.log("reducers");
            // console.log(action);
            return {...state, eventName: action.eventName, params: action.params};
        default:
            return state;
    }
};

export default googleAnalytics;